import axios from "axios";

export const TOKEN_KEY = "sb_token";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem(TOKEN_KEY)) {
      localStorage.removeItem(TOKEN_KEY);
      window.dispatchEvent(new Event("sb-logout"));
    }
    return Promise.reject(err);
  }
);

export const errMsg = (e, fallback = "Qualcosa è andato storto") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg.replace(/^Value error, /, "")).join(", ");
  return fallback;
};

export const PICKS = { fissa: ["1", "X", "2"], doppia: ["1X", "X2", "12"] };

export const fmtDate = (iso) =>
  new Date(iso).toLocaleString("it-IT", { weekday: "short", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

export const fmtPts = (n) => (Number.isInteger(n) ? n : Number(n || 0).toFixed(1));
